export enum EXCEPTION_CATEGORY_ENUM {
  JS_CATCH_BLOCK = 'js-catch-block',
  API_FAILURE = 'api-failure',
  API_EMPTY_RESPONSE = 'api-empty-response',
  JS_ERROR = 'js-error'
}

export enum EXCEPTION_FILE_NAMES_ENUM {
  MY_TRIPS_FIND_SERVICE = 'my-trips-find.service.ts',
  ENROLLMENT_DATA_SERVICE = 'enrollment-data.service.ts',
  ENROLLMENT_SERVICE = 'enrollment.service.ts',
  SEATS_JSON_SERVICE = 'seats-json.service.ts',
  SEATS_API_SERVICE = 'seats-api.service.ts',
  SERVICE_ANIMAL_REQUEST_SERVICE = 'service-animal-request.service.ts',
  LOGIN_CONTENT_SERVICE = 'login-content.service.ts',
  LOGIN_DASHBOARD_CALL = 'login-and-dashboard',
  LOGIN_CUSTOMER_CALL = 'login-customer-call',
  LOGIN_PING_OAUTH_SERVICE = 'ping-oauth.service.ts',
  FORGOT_LOGIN_CONTENT_SERVICE = 'forgot-login-content.service.ts',
  PROFILE_SELECTOR_CONTENT_SERVICE = 'profile-selector-content.service.ts',
  ADD_EMAIL_ADDRESS_API_SERVICE = 'add-email-address-api.service.ts',
  ADD_SQA_API_SERVICE = 'add-sqa-api.service.ts',
  ADD_ADDRESS_API_SERVICE = 'add-address-api.service.ts',
  IROP_SERVICE = 'irop.service.ts'
}

export enum TRACK_JS_METADATA_ENUM {
  PAGE_NAME = 'page-name',
  FILE_NAME = 'file-name',
  METHOD_NAME = 'method-name',
  EXCEPTION_CATEGORY = 'exception-category',
  EXCEPTION_MESSAGE = 'exception-message',
  APPLICATION_NAME = 'application'
}
